import { createSlice } from "@reduxjs/toolkit";

export const initialStateForDashboardSlice = {
  limit: 20,
  page: 0,
  sort_type: "asc",
  sort_key: "desc",
  search: "",
  totalCount: 0,
  totalPages: 0,
  list: [],
  filters: {},
  exceedMsg: "",
  showLoading:true,
  selectedInfluencers:[],
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState:initialStateForDashboardSlice,
  reducers: {
    updateDashboard: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetDashboard: () => {
      return initialStateForDashboardSlice;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateDashboard, resetDashboard } =
  dashboardSlice.actions;

export default dashboardSlice.reducer;
